import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import { literal } from 'lit/static-html.js';

import { EdgelessCRUDExtension } from './extensions/crud-extension';
import { EdgelessLegacySlotExtension } from './extensions/legacy-slot-extension';
import { SurfaceBlockComponent } from './surface-block';

export function surfaceViewingEffects() {
  if (!customElements.get('affine-surface'))
    customElements.define('affine-surface', SurfaceBlockComponent);
}
export function registerSurfaceViewing(context: ViewExtensionContext) {
  context.register([
    FlavourExtension('affine:surface'),
    EdgelessCRUDExtension,
    EdgelessLegacySlotExtension,
  ]);
}
export const surfaceViewingBlock = () =>
  BlockViewExtension('affine:surface', literal`affine-surface`);
export class SurfaceViewingExtension extends ViewExtensionProvider {
  override name = 'surface-viewing';
  override effect() {
    super.effect();
    surfaceViewingEffects();
  }
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    registerSurfaceViewing(context);
    context.register(surfaceViewingBlock());
  }
}
